import { createChart, IChartApi, ISeriesApi, CandlestickSeries } from 'lightweight-charts';
import Toast from './toast.js';

export default abstract class Charts {
    private static chart: IChartApi | null = null;
    private static candlestickSeries: ISeriesApi<'Candlestick'> | null = null;

    public static async init() {
        const container = document.getElementById('chart-canvas');
        if (!container) return;

        const style = getComputedStyle(document.body);
        const textColor = style.getPropertyValue('--theme-text-primary').trim() || '#DDD';
        const borderColor = style.getPropertyValue('--theme-border-color').trim() || '#334155';

        // Initialize Chart
        this.chart = createChart(container, {
            layout: {
                background: { color: 'transparent' },
                textColor: textColor,
            },
            grid: {
                vertLines: { color: borderColor },
                horzLines: { color: borderColor },
            },
            width: container.clientWidth,
            height: container.clientHeight,
        });

        this.candlestickSeries = this.chart.addSeries(CandlestickSeries, {
            upColor: '#26a69a',
            downColor: '#ef5350',
            borderVisible: false,
            wickUpColor: '#26a69a',
            wickDownColor: '#ef5350',
        });

        // Fetch real data on init
        await this.refreshData();

        this.chart.timeScale().fitContent();

        // Handle window resize
        window.addEventListener('resize', () => {
            if (this.chart && container) {
                this.chart.applyOptions({
                    width: container.clientWidth,
                    height: container.clientHeight,
                });
            }
        });

        this.initControls();
    }

    private static initControls() {
        const symbolSelector = document.getElementById('symbol-selector') as HTMLSelectElement;
        const intervalSelector = document.getElementById('interval-selector') as HTMLSelectElement;
        const refreshBtn = document.getElementById('refresh-chart');

        symbolSelector?.addEventListener('change', () => this.refreshData());
        intervalSelector?.addEventListener('change', () => this.refreshData());
        refreshBtn?.addEventListener('click', () => this.refreshData());
    }

    private static async refreshData() {
        if (!this.candlestickSeries) return;
        
        const symbol = (document.getElementById('symbol-selector') as HTMLSelectElement).value;
        const timeframe = (document.getElementById('interval-selector') as HTMLSelectElement).value;
        const accountNumber = localStorage.getItem('selectedAccount') || '';

        Toast.show(`Updating chart data for ${symbol}...`);
        
        try {
            const response = await fetch(`/api/charts/data?symbol=${symbol}&timeframe=${timeframe}&accountNumber=${accountNumber}`);
            const data = await response.json();

            if (data.error) {
                Toast.show('Error fetching chart data: ' + data.error, 'error');
                return;
            }

            this.candlestickSeries.setData(data);
            Toast.show('Chart updated successfully.', 'success');
        } catch (error) {
            console.error('Fetch error:', error);
            Toast.show('Failed to fetch chart data.', 'error');
        }
    }
}
